import type { StyleSystemProps } from '@withjoy/joykit';
import { CheckboxV2, Flex, TextV2, styled } from '@withjoy/joykit';
import type { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledAddressSummaryContent = styled(Flex)``;
const addressSummaryContentStyles: StyleSystemProps = {
  flexDirection: 'column',
  padding: '24px 32px 24px 24px',
  minWidth: '263px',
};

export const StyledAddressConfirmationContainer = styled(Flex)``;
const addressConfirmationContainerContentStyles: StyleSystemProps = {
  flexDirection: 'column',
  minHeight: ['unset', '974px', '974px'],
  height: ['100vh', 'unset', 'unset'],
};
export const StyledAddressSummaryTitle = styled(TextV2)``;
const addressSummaryTitleStyles: StyleSystemProps = {
  flex: '0 1 100%',
  marginTop: 8,
  marginBottom: 2,
  fontWeight: 'bold',
  typographyVariant: 'body1',
};

export const StyledAddressSummary = styled(Flex)``;
const addressSummaryStyles = (isSelected: boolean): StyleSystemProps => {
  return {
    flex: '0 1 100%',
    position: 'relative',
    cursor: 'pointer',
    _hover: { backgroundColor: 'gray3', borderColor: 'purple4', border: '1px solid' },
    _active: { backgroundColor: 'gray5', borderColor: 'fillDarkActive', border: '1px solid' },
    flexDirection: 'column',
    minWidth: [null, '380px'],
    borderRadius: '8px',
    border: isSelected ? '2px solid' : '1px solid',
    borderColor: isSelected ? 'fillDark' : 'gray3',
  };
};

export const StyledAddressCheckbox = styled(CheckboxV2)``;
const addressCheckboxStyles = (isChecked: boolean): CSSObject => {
  return {
    visibility: isChecked ? 'visible' : 'hidden',
    margin: '14px 14px 0 0',
    alignSelf: 'flex-end',
    position: 'absolute',
    ['> span']: {
      borderRadius: '10px',
    },
  };
};

export const styles = {
  addressSummary: addressSummaryStyles,
  addressCheckbox: addressCheckboxStyles,
  addressSummaryTitle: addressSummaryTitleStyles,
  addressSummaryContent: addressSummaryContentStyles,
  addressConfirmationContainerContent: addressConfirmationContainerContentStyles,
};
